<!--
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description:
-->
<template>
  <div class="login">
    <div class="login-container">
      <img class="logo" src="@/assets/images/logo.png" />
      <div class="login-container-bg"></div>
      <div class="login-content">
        <div class="login-title"><img src="@/assets/images/title.png" /></div>
        <form class="em-form">
          <div class="em-form-row" style="margin-top: 15px;">
            <i class="em-icon-user"></i>
            <div class="em-form-control login-form-control">
              <input type="text" id="code" name="code" autocomplete="off" placeholder="请输入用户名" v-model="account.code" />
            </div>
          </div>
          <div class="em-form-row">
            <i class="em-icon-lock"></i>
            <div class="em-form-control login-form-control">
              <input type="password" id="password" name="psw" placeholder="请输入密码" autocomplete="off" v-model="account.psw" />
            </div>
          </div>
          <div class="em-form-row" style="margin-bottom: 0;">
            <el-button type="warning" size="small" style="display:block; width: 100px; margin: 0 auto;" @click="submit">登录</el-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data: function () {
    return {
      account: {
        code: '',
        psw: ''
      }
    }
  },
  mounted: function () {
    const _this = this
    window.onkeydown = function (e) {
      const _currentPath = _this.$router.currentRoute.path
      if (_currentPath === '/') {
        if (e.keyCode === 13) {
          _this.submit()
        }
      }
    }
  },
  methods: {
    submit: function () {
      const _this = this
      _this.post(_this.$apis.login, { UserCode: _this.account.code, Password: _this.account.psw }, function (res) {
        const _json = res.data
        if (_json.status === 'ok') {
          sessionStorage.setItem('authorization', _json.token)
          sessionStorage.setItem('operator', _json.account.code)
          sessionStorage.setItem('operator_id', _json.account.id)
          sessionStorage.setItem('outsource_company_id', _json.account.outsource_company_id)
          sessionStorage.setItem('role_name', _json.account.role_name)
          sessionStorage.setItem('menus', JSON.stringify(_json.menus))
          sessionStorage.setItem('raw_menus', JSON.stringify(_json.raw_menus))
          if (_json.delivery_count === 0) {
            _this.resetSetItem('new_delivery_count', '')
          } else {
            _this.resetSetItem('new_delivery_count', _json.delivery_count)
          }
          _this.$router.push({
            path: '/home'
          })
        } else {
          if (_json.status === 'has-no-role') {
            _this.$message.error('用户没有任何权限')
          } else {
            _this.$message.error('用户名或密码错误')
          }
          _this.logout()
        }
      })
    }
  }
}
</script>
